<template>
  <n-menu ref="menu" class="overlay" :autoWidth="true" @mousedown.prevent>
    <n-menu-group>
      <n-list-item
        v-for="style in textStyle"
        :key="style.value"
        @click="onClick(style)"
        :text="$t(`textEditor.${style}`)"
      ></n-list-item>
    </n-menu-group>
  </n-menu>
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import NMenu from './core/NMenu/NMenu.vue'
import { TextStyle } from './TextStylingBar.vue'

@Component({
  computed: {}
})
export default class TextStyleDropdown extends Vue {
  @Prop() textStyle!: TextStyle

  @Ref('menu') menuRef!: NMenu

  open(openFrom: HTMLElement) {
    this.menuRef.open(openFrom)
  }

  close() {
    this.menuRef.close()
  }

  onClick(style: string) {
    this.$emit('onClick', style)
  }
}
</script>
